import { AdicionarComponenteComponent } from './adicionar-componente/adicionar-componente.component';
import { MatDialog } from '@angular/material/dialog';
import { ComponentesFilhosComponent } from './componentes-filhos/componentes-filhos.component';
import { Router } from '@angular/router';
import { ComponenteModel } from './../../../model/endereco/componente.model';
import { ModuloModel } from './../../../model/endereco/modulo.model';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ModuloService } from './../../../service/endereco/modulo.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ComponenteService } from './../../../service/endereco/componente.service';
import { AuthenticationService } from '@alfresco/adf-core';
import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { IActionMapping, ITreeOptions, TreeModel, TREE_ACTIONS } from 'angular-tree-component';
import { ArmazemService } from 'app/service/endereco/armazem.service';

const actionMapping: IActionMapping = {
  mouse: {
    dblClick: (tree, node, $event) => {
      if (node.hasChildren) {
        TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
      }
    },
    click: (tree, node, $event) => {
      $event.shiftKey
        ? TREE_ACTIONS.TOGGLE_ACTIVE_MULTI(tree, node, $event)
        : TREE_ACTIONS.TOGGLE_ACTIVE(tree, node, $event);
    }
  }
}

@Component({
  selector: 'app-componente',
  templateUrl: './componente.component.html',
  styleUrls: ['./componente.component.scss']
})
export class ComponenteComponent implements OnInit {

  options: ITreeOptions = {
    actionMapping: {
      mouse: {
        contextMenu: (tree, node, $event) => {
          $event.preventDefault();
          if (tree.focusedNodeId === null) {
            this.openSnackBarError('Selecione um item da listagem !');
          } else {
            if (node.position === 0) {
              let idModulo = tree.focusedNodeId.toString();
              idModulo.replace(':modulo','');
              this.addComponenteSet(parseInt(idModulo));
            } else {
              this.cadastroFilhos = false;
              this.emitirId(tree.focusedNodeId);
              this.cadastroFilhos = true;
              // this.addComponenteFilho(tree.focusedNodeId);
            }
          }
          // alert(`Componente: ${node.data.name} / Id: ${node.data.id}`);
        },
        dblClick: (tree, node, $event) => {
          if (node.hasChildren) TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
        },
        click: (tree, node, $event) => {
          $event.shiftKey
            ? TREE_ACTIONS.TOGGLE_ACTIVE_MULTI(tree, node, $event)
            : TREE_ACTIONS.TOGGLE_ACTIVE(tree, node, $event);
        }
      },
    }
  }
  adm = true;
  acervo = false;
  solicitacao = false;
  @Output() sendComponenteIdEvent = new EventEmitter<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  nodesTeste;
  moduloUnico
  public moduloSelecionado;
  public showAddModulo = false;
  public loading = false;
  public cadastroFilhos = false;
  public moduloPesquisado;
  public horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  public verticalPosition: MatSnackBarVerticalPosition = 'top';
  public modulos: ModuloModel[];
  public armazens: any;
  public componentes: ComponenteModel[];
  displayedColumns = ['modulo', 'nome','paridade','altura','largura', 'profundidade', 'posHoriz', 'posVert', 'ativo', 'acoes'];
  dataSource = new MatTableDataSource<ComponenteModel>([]);
  currentItem;
  public armazemEscolhido;
  public showModulos = false;
  public showModulo = false;
  public showArmazem = false;
  public nameModulo;
  public nameArmazem;

  constructor(private authService: AuthenticationService,
    private componenteService: ComponenteService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private armazemService: ArmazemService,
    private dialog: MatDialog,
    private moduloService: ModuloService) { }

  ngOnInit() {
    //this.getModulos();
    this.listarArmazensCliente();
  }

  search(e) {
    this.cadastroFilhos = false;
    console.log(e);
    this.nameArmazem = e.source.triggerValue;
    this.showArmazem = true;
    this.showModulo = false;
    this.armazemEscolhido = e.value;
    if (e.value === 0) {
      this.loading = false;
      this.openSnackBarError('Selecione um armazém para realizar a listagem !');
    }
    if (e.value > 0) {
      this.getModulosPorArmazem(e.value);
    }

  }

  searchModulo(e) {
    console.log(e);
    this.nameModulo = e.source.triggerValue;
    this.showModulo = true;
    if (e.value === 0) {
      this.loading = false;
      this.openSnackBarError('Selecione um módulo para realizar a listagem !');
    }
    if (e.value > 0) {
      this.moduloSelecionado = e.value;
      this.showAddModulo = true;
      this.nodesTree(e.value);
    }
  }

  getModulosPorArmazem(armazemId) {
    this.moduloService.getModuloByArmazem(armazemId).subscribe(data => {
      this.modulos = data;
      this.showModulos = true;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  listarArmazensCliente() {
    this.armazemService.listarArmazensUsuario().subscribe(data => {
      this.armazens = data;
    }, err => {
      console.error(err);
    });
  }

  emitirId(componenteId) {
    console.log('emitir:', componenteId);
    this.currentItem = componenteId;
    this.sendComponenteIdEvent.emit(componenteId);
  }

  addComponenteFilho(componenteId) {
    const dialogRef = this.dialog.open(ComponentesFilhosComponent, {
      width: '100%',
      data: {componenteId: componenteId}
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  nodesTree(moduloId) {
    this.loading = true;
    this.componenteService.nodesTree(moduloId).subscribe(data => {
      //console.log(data);
      this.nodesTeste = [data];
      this.nodesTeste[0].id = this.nodesTeste[0].id+':modulo';
      setTimeout(() => {
        this.loading = false;
      }, 1000);
      console.log(this.nodesTeste);
    }, err => {
      this.loading = false;
      console.error(err);
    });
  }

  listarComponenteModulo(moduloId: Number) {
    this.loading = true;
    this.componenteService.listarComponentesModulo(moduloId).subscribe(data => {
      if (data.length === 0) {
        this.openSnackBarError('Nenhum Componente cadastrado neste módulo !');
        this.loading = false;
      } else {
        this.componentes = data;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        console.log(data);
        this.loading = false;
      }
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  addComponente() {
    const dialogRef = this.dialog.open(AdicionarComponenteComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  addComponenteSet(moduloId) {
    const dialogRef = this.dialog.open(AdicionarComponenteComponent, {
      width: '100%',
      data: {modulo: moduloId}
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  excluirComponente(moduloId) {
    moduloId = this.moduloPesquisado;
    this.componenteService.excluirComponentes(moduloId).subscribe(() => {
      alert("Excluido");
    }, err => {
      console.error(err);
    });
  }

  getModulos() {
    this.moduloService.getModulos().subscribe(data => {
      this.modulos = data.content;
    }, err => {
      console.error(err);
    });
  }

  goComponentes(componenteId: number) {
    console.log(componenteId);
    const idCrypt = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(componenteId), 'pcdoc').toString());
    console.log(idCrypt);
    this.router.navigate(['componente', idCrypt]);
  }

   /*const dialogRef = this.dialog.open(ComponentesFilhosComponent, {
      width: '100%',
      data: {componente: componente}
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });*/

  send() {
    this.router.navigate(['componente']);
  }

  onSearch() {
    this.cadastroFilhos = false;
    let value = (<HTMLSelectElement>document.getElementById('selectCliente')).value;
    this.moduloPesquisado = parseInt(value);
    if(parseInt(value) == 0) {
      this.openSnackBarError('Nenhum Módulo selecionado !');
      return null;
    }
    this.modulos.map(element => {
      if (element.id === (parseInt(value))) {
        this.moduloUnico = element;
      }
    });
    this.listarComponenteModulo(parseInt(value));
    this.nodesTree(parseInt(value));
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/endereco-components/componente/componente.component.ts